import type { IIconsButtonProps } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { EducationalVideoModal } from "pro-features/components/Modals/src/EducationalVideoModal";
import {
    StyledTutorialButtonWrapper,
    StyledTutorialCustomWrapper,
} from "app/pages/sales-intelligence/common-components/TutorialView/styles";
import type { EducationData } from "app/pages/sales-intelligence/types/educationData";
import type { MouseEvent, MouseEventHandler, PropsWithChildren, ReactElement } from "react";
import { useState } from "react";

interface Props extends Omit<IIconsButtonProps, "iconName"> {
    educationData: Readonly<EducationData>;
    tutorialButton?: ReactElement;
    onMouseEnter?: MouseEventHandler;
    onMouseLeave?: MouseEventHandler;
}

export type TutorialViewProps = PropsWithChildren<Props>;

function TutorialView({
    educationData,
    isDisabled,
    tutorialButton,
    children,
    onClick,
    onMouseEnter,
    onMouseLeave,
    ...props
}: TutorialViewProps): ReactElement {
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    function openTutorialVideo(e?: MouseEvent) {
        if (!educationData.video) {
            return undefined;
        }

        setIsVideoModalOpen(true);
        onClick?.(e);
    }

    // todo remove zendesk join
    const link = educationData.video && [educationData.video, educationData.zendesk].join("/");
    const isButtonDisabled = !educationData.video || isDisabled;

    return (
        <div>
            {tutorialButton ? (
                <StyledTutorialCustomWrapper
                    data-automation="tutorial-button"
                    isDisabled={isButtonDisabled}
                    onClick={openTutorialVideo}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                >
                    {tutorialButton}
                </StyledTutorialCustomWrapper>
            ) : (
                <StyledTutorialButtonWrapper
                    isDisabled={isButtonDisabled}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                >
                    <IconButton
                        dataAutomation="tutorial-button"
                        type="flat"
                        {...props}
                        iconName="Video-icon"
                        isDisabled={isButtonDisabled}
                        onClick={openTutorialVideo}
                    >
                        {children}
                    </IconButton>
                </StyledTutorialButtonWrapper>
            )}

            <EducationalVideoModal
                shouldCloseOnOverlayClick
                videoConfig={{
                    url: `https://vimeo.com/${link}`,
                    videoConfig: {
                        autoPlay: true,
                        width: "100%",
                        height: "100%",
                    },
                }}
                isOpen={isVideoModalOpen}
                onCloseClick={() => setIsVideoModalOpen(false)}
            />
        </div>
    );
}

export default TutorialView;
